import { SyntheticEvent, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import validator from 'validator';
import { CircularProgress } from '@mui/material';

import { subscribe } from '../../api/subscribers';
import { reducerTypes } from '../../store/Alert/types';
import { useAppSelector } from '../../hooks/reduxHooks';
import { Form, Input, Button } from './SubscribeForm.styled';

const SubscribeForm = () => {
  const [email, setEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      subscribe_placeholder: locale['footer_subscribe_placeholder'],
      subscribe_button_text: locale['footer_subscribe_button_text'],
      succesful: locale['footer_subscribe_apply_form_succesful'],
      failed: locale['footer_subscribe_apply_form_failed'],
    };
  }, [locale]);

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    applyForm();
  };

  async function applyForm() {
    if (!validator.isEmail(email)) return;
    try {
      setLoading(true);
      await subscribe(email);
      dispatch({
        type: reducerTypes.TOGGLE_ALERT,
        payload: {
          text: `${messages.succesful}`,
          isPrompt: false,
        },
      });
      setEmail('');
    } catch (e) {
      alert(`${messages.failed}`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Input placeholder='EMAIL' value={email} onChange={({ target }) => setEmail(target.value)} />
      <Button type='submit' name={messages.subscribe_button_text} disabled={loading}>
        {loading ? <CircularProgress color='inherit' size={20} /> : messages.subscribe_button_text ?? 'SUBSCRIBE'}
      </Button>
    </Form>
  );
};
export default SubscribeForm;
